import React from "react";
import useIsMobile from "../../utils/useIsMobile";
import useIsTab from "../../utils/useIsTab";

const IntroPageSkeleton = () => {
  let isMobile = useIsMobile();
  let isTab = useIsTab();

  let isMobileOrTab = isMobile || isTab;

  return (
    <div className="flex flex-1 w-full">
      <div className="flex flex-col flex-1 py-3 px-3 lg:py-10 lg:px-8 xl:px-14">
        <div
          style={{
            backgroundImage:
              !isMobileOrTab &&
              "linear-gradient(360deg, rgba(107, 107, 184, 0) 81.6%, rgba(107, 107, 184, 0.1) 100%)",
          }}
          className="flex flex-col lg:w-3/5 xl:w-1/2 h-full justify-between lg:border lg:border-gray-275 rounded-xl lg:p-5"
        >
          <div className="w-full mt-0">
            <p className="hidden lg:block text-4xl text-black-150 font-extrabold mb-0">
              Start Your Journey
            </p>

            <div className="lg:mt-14">
              <label htmlFor="referenceNo" className="block text-gray-150">
                Reference No.
              </label>
              <div className="h-11 py-2 mt-3 border rounded-md focus:outline-none bg-gray-100 w-full animate-pulse" />

              <label
                htmlFor="language"
                className="block text-gray-150 mt-6 mb-3"
              >
                Language
              </label>
              <div className="h-11 py-2 mt-3 border rounded-md focus:outline-none bg-gray-100 w-full animate-pulse" />
            </div>
          </div>
          <button className="w-full lg:max-w-max bg-orange-150 font-semibold text-white py-2 px-4 rounded-md disabled:cursor-not-allowed">
            Start Your Journey
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntroPageSkeleton;
